export const PlacementIds = {
  AppSwitcherDiscoverySection: 'app-switcher-discovery-section',
  BoardScreen: 'trello-board-screen',
  BoardsHomeScreen: 'boards-home-screen',
} as const;
